module.exports = __webpack_public_path__ + "static/media/cq_inoltra b.a2c32dc9.svg";